import dynamic from 'next/dynamic';

import { HBBannerTwoRowsWidgetProps } from './HBBannerTwoRowsWidget';
import { HBBrandWidgetProps } from './HBBrandWidget';
import { HBBuyerCategoryWidgetProps } from './HBBuyerCategoryWidget';
import { HBFiveAdsWidgetProps } from './HBFiveAdsWidget';
import { HBHTMLWidgetProps } from './HBHTMLWidget';
import { HBImageSliderThreeWidgetProps } from './HBImageSliderThreeWidget';
import { HBImageSliderWidgetProps } from './HBImageSliderWidget';
import { HBImageWidgetProps } from './HBImageWidget';
import { HBLiveWidgetProps } from './HBLiveWidget';
import { HBMostWidgetProps } from './HBMostWidget';
import { HBOfferCardMultiRowWidgetProps } from './HBOfferCardMultiRowWidget';
import { HBProductGroupWidgetProps, ProductGroupType } from './HBProductGroupWidget';
import { HBSellerListWidgetProps } from './HBSellerWidget/HBSellerListWidget';
import { ThreeIdsProps } from './HBThreeAdsWidget';
import { HBVideoWidgetProps } from './HBVideoWidget';

export { HBCardWidget } from './HBCardWidget/HBCardWidget';
export { HBCardWidgetList } from './HBCardWidget/HBCardWidgetList';
export { HBImageSliderWidget } from './HBImageSliderWidget';

export const HBBannerTwoRowsWidget = dynamic<HBBannerTwoRowsWidgetProps>(() =>
  import('./HBBannerTwoRowsWidget').then((module) => module.HBBannerTwoRowsWidget),
);
export const HBBrandWidget = dynamic<HBBrandWidgetProps>(() =>
  import('./HBBrandWidget').then((module) => module.HBBrandWidget),
);
export const HBBuyerCategoryWidget = dynamic<HBBuyerCategoryWidgetProps>(() =>
  import('./HBBuyerCategoryWidget').then((module) => module.HBBuyerCategoryWidget),
);
export const HBFiveAdsWidget = dynamic<HBFiveAdsWidgetProps>(() =>
  import('./HBFiveAdsWidget').then((module) => module.HBFiveAdsWidget),
);
export const HBHTMLWidget = dynamic<HBHTMLWidgetProps>(() =>
  import('./HBHTMLWidget').then((module) => module.HBHTMLWidget),
);
export const HBImageSliderThreeWidget = dynamic<HBImageSliderThreeWidgetProps>(() =>
  import('./HBImageSliderThreeWidget').then((module) => module.HBImageSliderThreeWidget),
);

export const HBImageWidget = dynamic<HBImageWidgetProps>(() =>
  import('./HBImageWidget').then((module) => module.HBImageWidget),
);
export const HBLiveWidget = dynamic<HBLiveWidgetProps>(() =>
  import('./HBLiveWidget').then((module) => module.HBLiveWidget),
);
export const HBMostWidget = dynamic<HBMostWidgetProps>(() =>
  import('./HBMostWidget').then((module) => module.HBMostWidget),
);
export const HBOfferCardMultiRowWidget = dynamic<HBOfferCardMultiRowWidgetProps>(() =>
  import('./HBOfferCardMultiRowWidget').then((module) => module.HBOfferCardMultiRowWidget),
);
export const HBProductGroupWidget = dynamic<HBProductGroupWidgetProps>(() =>
  import('./HBProductGroupWidget').then((module) => module.HBProductGroupWidget),
);
export const HBSellerWidget = dynamic<HBSellerListWidgetProps>(() =>
  import('./HBSellerWidget/HBSellerListWidget').then((module) => module.HBSellerListWidget),
);
export const HBThreeAdsWidget = dynamic<ThreeIdsProps>(() =>
  import('./HBThreeAdsWidget').then((module) => module.HBThreeAdsWidget),
);
export const HBVideoWidget = dynamic<HBVideoWidgetProps>(() =>
  import('./HBVideoWidget').then((module) => module.HBVideoWidget),
);

export type { ICardWidgetListProps } from './HBCardWidget/HBCardWidgetList';
export type { CardType, CollectionData, HBCardWidgetProps } from './HBCardWidget/HBCardWidgetType';
export type {
  HBBannerTwoRowsWidgetProps,
  HBBrandWidgetProps,
  HBBuyerCategoryWidgetProps,
  HBFiveAdsWidgetProps,
  HBHTMLWidgetProps,
  HBImageSliderThreeWidgetProps,
  HBImageSliderWidgetProps,
  HBImageWidgetProps,
  HBLiveWidgetProps,
  HBMostWidgetProps,
  HBOfferCardMultiRowWidgetProps,
  HBProductGroupWidgetProps,
  HBSellerListWidgetProps,
  HBVideoWidgetProps,
  ProductGroupType,
  ThreeIdsProps,
};
